import React from "react";
import { View, Text, Image, StyleSheet } from "@react-pdf/renderer";
import Logo from '../../views/dataspec/export/images/logo.png';
const styles = StyleSheet.create({

    header: {
        flexDirection: "row",
        alignItems: "center",
        borderBottom: "1px solid #e5e7eb",
        paddingBottom: 10,
        marginBottom: 15
    },

    logo: {
        width: 112,
        height: 23
    },

    headerRight: {
        marginLeft: "auto",
        textAlign: "right"
    },

    title: {
        fontSize: 16,
        fontWeight: 600
    },

    subtitle: {
        fontSize: 10,
        color: "#6b7280"
    }

});

export const PdfHeader = ({ title }) => (

    <View style={styles.header}>

        <Image
            style={styles.logo}
            src={Logo}
            style={styles.logo}
        />

        <View style={styles.headerRight}>
            <Text style={styles.title}>{title}</Text>
            <Text style={styles.subtitle}>Generated from Tagstand</Text>
        </View>

    </View>

);